import React from 'react';
import { useProgress } from 'components/layout_and_quote_builder/utils/ProgressContext.jsx';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import frankStyles from 'components/frank/_style.module.scss';

// The listing's modal, blocking progress popup while its manufacturing lines are scored: the legacy
// ProgressBarOverlay's card, but titled for what is actually happening (rather than the legacy "Loading Layout
// Combinations") and with a bar that sweeps until the first line answers before it starts counting percentage.
// The shared ProgressBarOverlay is left EXACTLY as it is for the legacy Manufacturing Cost Calculator page;
// Frank renders this instead, so none of it changes anything outside /mcc.
//
// It reuses the shared overlay's styles (progressOverlay / progressCard / progressTitle / progressBarContainer /
// progressBarFill / progressPercentage), so the card is the legacy one; only the title and the pre-first-answer
// sweep (frank/_style.module.scss's indeterminateFill) are Frank's own.
//
// WHERE THIS SHOWS: the LEGACY STACKED view only. Its render site is gated on `!stageView`, and stageView is set
// by BOTH stage surfaces -- the guided setup wizard and the section's page tabs -- which show WizardSearchProgress
// inline instead (see the stageView contract in ManufacturingLineLists). That is also why the title is plain
// English rather than a t() key: translation follows `stageView != null`, so the stacked view keeps its exact
// English and both stage surfaces are translated.
// onCancel stops the very scoring pass this popup is reporting. It is the only control the popup offers -- and
// it has to be here, because the popup is modal: while it is up, the filter block behind it cannot be reached.
const ListingProgressOverlay = ({ onCancel }) => {
  const { progress } = useProgress();

  // Nothing queued, or every line already scored -- the popup has nothing to report.
  if (progress.total === 0 || progress.completed === progress.total) {
    return null;
  }

  // Until the first line's best score lands, `completed` is 0 -- a determinate bar would sit frozen at 0% for
  // the whole first (cold) best-score request, the one that loads all the dieline geometry: 5.5s measured on the
  // reference quote, and longer while the first requests race each other for that same cold geometry. A frozen
  // number reads as broken, so sweep instead, and switch to the determinate percentage bar once results land.
  const started = progress.completed > 0;

  return (
    <div className={styles.progressOverlay}>
      <div className={styles.progressCard}>
        <div className={styles.progressTitle}>Scoring manufacturing options…</div>
        <div className={styles.progressBarContainer}>
          {started ? (
            <div className={styles.progressBarFill} style={{ width: `${progress.percentage}%` }}>
              <span className={styles.progressPercentage}>{progress.percentage}%</span>
            </div>
          ) : (
            <div className={frankStyles.indeterminateFill} />
          )}
        </div>
        {onCancel && (
          <div style={{ marginTop: '16px', textAlign: 'center' }}>
            {/* Plain English, like the title above and for the same reason: this popup is the LEGACY STACKED
                view's only. */}
            <button
              type="button"
              data-cancel-search
              onClick={onCancel}
              className="dct-button dct-button--secondary dct-button--small"
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListingProgressOverlay;
